import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import {DEFAULT_CITIES} from 'src/shared/consts'
import type {LocationDetect, LocationDetectedVariant, LocationDetectResult} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

export function fetchDetectLocationDeprecated(body: LocationDetect): Promise<LocationDetectedVariant[]> {
  return fetch<LocationDetect, LocationDetectResult, LocationDetectResult>({
    url: addQuery(externalApiURL('/platform/location/detect'), {country: appConfig.countryCode}),
    method: 'post',
    body,
  }).then(result => {
    if (result?.variants === undefined || result.variants.length === 0) {
      return DEFAULT_CITIES
    }

    return result.variants
  })
}
